import { usePaywallContext } from '@frontend/react-domain';
import { Icon, Text, XStack, YStack } from '@frontend/web-react';

export type PromotionSummaryCardProps = {
  onCancel: () => void;
};

export const PromotionSummaryCard = ({ onCancel }: PromotionSummaryCardProps) => {
  const { paywallState } = usePaywallContext();
  return (
    <XStack
      alignItems="center"
      className="rounded-lg border-2 border-borderPrimary bg-trueWhite"
      gapX="md"
      gapY="md"
      p="lg"
    >
      <XStack alignItems="center" className="flex-1" gapX="md">
        <Icon className="text-textSecondary" name="IconGift" size={24} />
        <YStack className="shrink">
          <Text type="h5">{paywallState.promotionTranslation.promotionName}</Text>
          <YStack className="shrink">
            <Text type="p-sm">{paywallState.promotionTranslation.promotionDescription}</Text>
          </YStack>
        </YStack>
      </XStack>
      <Icon accessibilityLabel='Cancel promotion' name="IconX" onClick={onCancel} size={20} />
    </XStack>
  );
};
